import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/pregnancy-monitoring/#webpage",
   "url": "https://www.futurefamilyai.com/pregnancy-monitoring/",
   "name": "Pregnancy Health Monitoring at Home | FutureFamilyAI",
   "description": "Monitor blood pressure, heart rate, sleep and symptoms at home in every trimester, with care-team review when it matters. Free pilot open now.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Pregnancy Monitoring",
     "item": "https://www.futurefamilyai.com/pregnancy-monitoring/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is it safe to monitor blood pressure at home during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Home measurement with a validated upper-arm cuff is a common part of prenatal care when your clinician recommends it. Follow their instructions on timing, positioning and what to do with high readings."
     }
    },
    {
     "@type": "Question",
     "name": "What should I track during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Your clinician will guide you, but useful items include blood pressure, symptoms such as headache or swelling, sleep and activity. FutureFamilyAI collects these in one place for your appointments."
     }
    },
    {
     "@type": "Question",
     "name": "Can remote monitoring catch problems early?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It can help you and your care team notice trends sooner, which supports earlier conversations. It cannot diagnose or predict a condition, and it never replaces urgent care for severe symptoms."
     }
    },
    {
     "@type": "Question",
     "name": "Will my obstetrician see my data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only if you share it. You can invite your clinician to view readings, trends or a summary, and stop sharing at any time."
     }
    },
    {
     "@type": "Question",
     "name": "Do I still need prenatal appointments?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. FutureFamilyAI adds context between visits; it does not replace any appointment, test or ultrasound your care team recommends."
     }
    },
    {
     "@type": "Question",
     "name": "When should I start using a pregnancy monitoring app?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Any time — many members start early in pregnancy so their baseline is in place before the third trimester, when blood pressure changes are more common."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  },
  {
   "@type": "MobileApplication",
   "name": "FutureFamilyAI",
   "operatingSystem": "iOS, Android",
   "applicationCategory": "HealthApplication",
   "offers": [
    {
     "@type": "Offer",
     "price": "0",
     "priceCurrency": "USD",
     "description": "Free pilot through December 31, 2026",
     "priceValidUntil": "2026-12-31"
    },
    {
     "@type": "Offer",
     "price": "39.99",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, monthly (after pilot)"
    },
    {
     "@type": "Offer",
     "price": "399",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, annual (after pilot)"
    }
   ],
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   }
  }
 ]
}`;

export default function PregnancyMonitoringPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Pregnancy Monitoring</span>
            </nav>

            <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  {/* <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span> */}
                  <h1>
                    Stay Ahead of Your Pregnancy Wellness
                  </h1>

                  <p className="ffh-lead speakable-content">
                    Monitor blood pressure and wellness trends from home with FutureFamilyAI. Receive simple status updates and care-team-reviewed alerts while staying connected with your healthcare provider throughout pregnancy and postpartum recovery.
                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Proactive Monitoring. Physician-Connected Care. Greater Peace of Mind.
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">Download the App </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">How Monitoring Works</a>
                    </div>
                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
               <iframe width="100%" height="365" src="https://www.youtube.com/embed/qxYiK7W3q4Y" title="Gestational Surrogate Support Between Prenatal Visits | FutureFamilyAI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>

            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Pregnancy health monitoring at home means tracking blood
                pressure with a validated cuff, plus heart rate, sleep, activity
                and symptoms, between prenatal visits.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting mothers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      The USPSTF recommends screening for hypertensive disorders
                      of pregnancy with blood pressure measurements throughout
                      pregnancy. (USPSTF, 2023)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Designed around each trimester · Your clinician gets
                      organized trends, not screenshots · Calm guidance instead
                      of internet searching at midnight
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact-us/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FOR EXPECTING MOTHERS</span>
            <h1>Pregnancy Health Monitoring at Home, Every Trimester</h1>
            <p className="ffh-answer speakable-content">
              Pregnancy health monitoring at home means tracking blood pressure
              with a validated cuff, plus heart rate, sleep, activity and
              symptoms, between prenatal visits. USPSTF recommends blood
              pressure measurement throughout pregnancy. FutureFamilyAI turns
              those daily readings into one color status and routes Orange and
              Red patterns to a real care team. It supports — never replaces —
              your prenatal care. Request free pilot access today.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
              <Link className="ffh-btn ffh-ghost" to="/contact-us?type=member">
                Request Free Pilot Access
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Expectant mother reviewing her pregnancy wellness trends at home"
              >
                <img
                  src="/images/warm-portrait.jpg"
                  alt=" Expectant mother reviewing her pregnancy wellness  trends at home" />
               
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                  <li>
                    Routine prenatal visits are commonly scheduled about every
                    four weeks until roughly 28 weeks of pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/womens-health/faqs/having-a-baby">
                        ACOG
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>First trimester: build your baseline</h2>
                <p>
                  Early readings matter because they show what is normal for
                  you. FutureFamilyAI builds a personal baseline over the first
                  one to two weeks so later changes are measured against your
                  own numbers, not a generic chart.
                </p>
              </section>
              <section id="s2">
                <h2>Second trimester: stay consistent</h2>
                <p>
                  Blood pressure often dips mid-pregnancy and then rises again.
                  Consistent daily checks help your care team distinguish
                  expected changes from a trend worth discussing.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
              <section id="s3">
                <h2>
                  Third trimester and beyond: the window that matters most
                </h2>
                <p>
                  Hypertensive disorders most often appear after 20 weeks and
                  can continue after delivery. FutureFamilyAI keeps monitoring
                  through the third trimester and into postpartum, so nothing
                  resets when the baby arrives.
                </p>
              </section>
              <section id="s4">
                <h2>Peace of mind without the noise</h2>
                <p>
                  You will not see dozens of numbers to decode. You will see one
                  status, a sentence of guidance, and a record your clinician
                  can review — so your daily check takes two minutes, not your
                  whole evening.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      Is it safe to monitor blood pressure at home during
                      pregnancy?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. Home measurement with a validated upper-arm cuff is
                        a common part of prenatal care when your clinician
                        recommends it. Follow their instructions on timing,
                        positioning and what to do with high readings.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What should I track during pregnancy?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Your clinician will guide you, but useful items include
                        blood pressure, symptoms such as headache or swelling,
                        sleep and activity. FutureFamilyAI collects these in one
                        place for your appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can remote monitoring catch problems early?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        It can help you and your care team notice trends sooner,
                        which supports earlier conversations. It cannot diagnose
                        or predict a condition, and it never replaces urgent
                        care for severe symptoms.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Will my obstetrician see my data?</summary>
                    <div className="ffh-ans">
                      <p>
                        Only if you share it. You can invite your clinician to
                        view readings, trends or a summary, and stop sharing at
                        any time.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Do I still need prenatal appointments?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes. FutureFamilyAI adds context between visits; it does
                        not replace any appointment, test or ultrasound your
                        care team recommends.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      When should I start using a pregnancy monitoring app?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Any time — many members start early in pregnancy so
                        their baseline is in place before the third trimester,
                        when blood pressure changes are more common.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <a className="ffh-btn ffh-primary" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/how-it-works">How It Works →</Link>
                  <Link to="/pricing">Pricing →</Link>
                  <Link to="/about">About &amp; Clinical Oversight →</Link>
                  <Link to="/privacy-safety">Privacy &amp; Safety →</Link>
                  <Link to="/faq">Frequently Asked Questions →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">First trimester: build your baseline</a>
                  </li>
                  <li>
                    <a href="#s2">Second trimester: stay consistent</a>
                  </li>
                  <li>
                    <a href="#s3">
                      Third trimester and beyond: the window that matters most
                    </a>
                  </li>
                  <li>
                    <a href="#s4">Peace of mind without the noise</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <a className="ffh-btn ffh-primary ffh-sm" href={APP_STORE_URL}>
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                  Download on the App Store
                </a>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
